import script from "./AnalysisResult.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisResult.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisResult.vue?vue&type=style&index=0&id=1d8f9cb0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d8f9cb0"]])

export default __exports__